import React from "react";
import skatingWebp from "../assets/skating_transparent.webp";

interface SkatingMascotProps {
  className?: string;
  width?: string | number;
}

const SkatingMascot: React.FC<SkatingMascotProps> = ({
  className = "",
  width,
}) => {
  const wrapperStyle: React.CSSProperties = {
    padding: "24px",
    display: "flex",
    justifyContent: "center",
  };

  const imgStyle: React.CSSProperties = {
    maxWidth: width || "320px",
    width: "100%",
    height: "auto",
    display: "block",
  };

  return (
    <div className={className} style={wrapperStyle}>
      <img
        src={skatingWebp}
        alt="Sarsfield Oldtimers skating mascot"
        loading="lazy"
        style={imgStyle}
      />
    </div>
  );
};

export default SkatingMascot;
